<footer class="footer__1">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 space-y-20">
                <div class="footer__logo">
                    <a routerLink="/">
                        <img src="assets/images/nft-logo.png" alt="logo">
                    </a>
                </div>
                <p class="footer__text">
                    The world’s first and largest digital marketplace for crypto collectibles and 
                    non-fungible tokens (NFTs). 
                    Buy, sell, and discover exclusive digital items.
                </p>
                <div *ngIf="socialInfo != null">
                    <ul class="footer__social space-x-10 mb-40">
                        <li> <a href="{{socialInfo.facebook}}" target="_blank"> <i class="fa fa-facebook"></i> </a>
                        </li>
                        <li> <a href="{{socialInfo.pinterest}}" target="_blank"> <i class="fa fa-pinterest"></i> </a>
                        </li>
                        <li> <a href="{{socialInfo.twitter}}" target="_blank"> <i class="fa fa-twitter"></i> </a>
                        <li> <a href="{{socialInfo.linkedin}}"> <i class="fa fa-linkedin"></i> </a>
                        </li>
                        <li> <a href="{{socialInfo.youtube}}" target="_blank"> <i class="fa fa-youtube"></i> </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-6">
                <h6 class="footer__title">Marketplace</h6>
                <ul class="footer__list">
                    <li> <a routerLink="/"> All NFTs </a></li>
                    <li> <a routerLink="/"> Art </a></li>
                    <li> <a routerLink="/"> Music</a> </li>
                    <li> <a routerLink="/"> Sports </a> </li>
                    <li> <a routerLink="/"> Domain names</a> </li>
                </ul>
            </div>
            <div class="col-lg-2 col-6">
                <h6 class="footer__title">My Account</h6>
                <ul class="footer__list">
                    <li> <a routerLink="/"> Profile </a>
                    </li>
                    <li> <a routerLink="/"> My Favarites </a>
                    </li>
                    <li> <a routerLink="/"> My Colletctions </a>
                    </li>
                    <li> <a routerLink="/"> Activity
                        </a> </li>
                </ul>
            </div>
            <div class="col-lg-2 col-6">
                <h6 class="footer__title">Resources</h6>
                <ul class="footer__list">
                    <li *ngIf="termsConditionInfo != null"><a href="{{termsConditionInfo.url}}">{{termsConditionInfo.name}}</a></li>
                    <!-- <li><a href="{{helpCenterInfo.url}}">{{helpCenterInfo.name}}</a></li> -->
                    <li *ngIf="privacyPolicyInfo != null"><a href="{{privacyPolicyInfo.url}}">{{privacyPolicyInfo.name}}</a></li>
                    <li *ngIf="careerInfo != null"><a href="{{careerInfo.url}}">{{careerInfo.name}}</a></li>
                    <!-- <li><a href="{{socialMediaInfo.url}}">{{socialMediaInfo.name}}</a></li> -->
                    <!-- <li><a href="{{contactUsInfo.url}}">{{contactUsInfo.name}}</a></li> -->
                    <li *ngIf="blogsInfo != null"><a href="{{blogsInfo.url}}">{{blogsInfo.name}}</a></li>
                    <li *ngIf="faqsInfo != null"><a href="{{faqsInfo.url}}">{{faqsInfo.name}}</a></li>
                    <!-- <li><a href="{{templatesInfo.subject}}">{{templatesInfo.subject}}</a></li> -->
                </ul>
            </div>
        </div>
        <p class="copyright text-center">
            © Copyright 2022 - MUZELLA NFT
        </p>
    </div>
</footer>